import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import DefaultSEO from '../components/DefaultSEO';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-white">
      <DefaultSEO title="404 - Page Not Found | ZoyoTrip" />
      <div className="container text-center">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="mb-4">
              <h1 className="display-1 fw-bold text-primary mb-0" style={{ fontSize: '100px', opacity: 0.1, letterSpacing: '-5px' }}>404</h1>
              <div style={{ marginTop: '-3rem' }} className="position-relative">
                <h2 className="fw-bold text-dark mb-3">Oops! Page not found</h2>
                <p className="text-muted fs-5 mb-5 mx-auto" style={{ maxWidth: '400px' }}>
                  The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                </p>
              </div>
            </div>

            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
              <button
                onClick={() => navigate(-1)}
                className="btn btn-outline-primary rounded-pill px-4 py-2 fw-semibold d-flex align-items-center justify-content-center gap-2"
              >
                <ArrowLeft size={18} /> Go Back
              </button>
              <button
                onClick={() => navigate('/')}
                className="btn btn-primary rounded-pill px-4 py-2 fw-semibold d-flex align-items-center justify-content-center gap-2 shadow-sm"
              >
                <Home size={18} /> Back to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;